import { Pipe, PipeTransform } from '@angular/core';
import { socialLabelFor } from './social-brands';

/**
 * Accessible label for a social link, decoupled from the raw CMS `social_name`.
 * Lets the anchor `title` read "X" while the `footer_social` row still says
 * "twitter".
 */
@Pipe({ name: 'socialLabel' })
export class SocialLabelPipe implements PipeTransform {
  transform(name: string): string {
    return socialLabelFor(name);
  }
}
